define(function () {
	const IPS = require('../base/ipsModelCollection')
	return IPS.extend({
		urlRoot: '/delegate/civics-api/api/core/codedescriptions/',
		url: function () {
			// set the moniker and it will append it to the url
			if (this.moniker)
				return this.urlRoot + this.moniker;
			if (this.instrumentType) {
				this.applicantTypeMoniker = this.getMoniker(this.instrumentType);
				return this.urlRoot + this.applicantTypeMoniker;
			}
			return this.urlRoot
		},
		parse: function (r) {
			_.each(r.data.codeDescriptionItems, function (codeDescript) {
				if (codeDescript.description == null || codeDescript.description.trim().length <= 0) {
					codeDescript.description = i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
				}
			});

			let ret = r.data.codeDescriptionItems;
			if (this.instrumentType || this.removeNoneOptions === true) {
				ret = r.data.codeDescriptionItems.filter((item) => {
					return item.code != 'None';
				})
			}
			this.responseStatus = r.responseStatus;
			return ret;
		},
		getMoniker: function () {
			switch (this.instrumentType.toLowerCase()) {
				case "building":
					return "Hansen.CDR.Building.BuildingApplicantType";
				case "businesslicense":
					return "Hansen.CDR.BusinessLicense.OtherContactType";
				case "codeenforcement":
					return "Hansen.CDR.CodeEnforcement.CaseContactType";
				case "planning":
					return "Hansen.CDR.Planning.PlanningApplicantType";
				case "project":
					return "Hansen.CDR.Project.ProjectApplicantType";
				case "tradelicense":
					return "Hansen.CDR.TradeLicense.OtherContactType";
				case "use":
					return "Hansen.CDR.Use.UseApplicantType";
				default:
					return "";
			}
		},
	});
});
